/**
 * @file Square button with Bootstrap icon that opens DataPortabilityPanel in a modal
 * @version 1.0.0
 * @author Claude Assistant
 * @since 2025-07-09
 */

import DataPortabilityPanel from './DataPortabilityPanel.js';

const { ref, computed } = Vue;

export default {
  name: 'DataPortabilityButton',

  inheritAttrs: false,

  components: {
    DataPortabilityPanel,
  },

  template: `
    <!-- Trigger Button -->
    <button 
      type="button" 
      class="btn"
      :class="Object.values($attrs).length ? '': 'btn-secondary'"
      @click="openModal"
      v-bind="$attrs"
    > 
      <i class="bi-database-fill-gear"></i>
    </button>
    
    <!-- Modal -->
    <div 
      class="modal fade" 
      :id="modalId"
      tabindex="-1" 
      aria-labelledby="dataPortabilityModalLabel"
      aria-hidden="true"
      ref="modal"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="dataPortabilityModalLabel">
              <i class="bi-database-fill-gear me-2"></i>
              Data Portability
            </h5>
            <button 
              type="button" 
              class="btn-close" 
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <DataPortabilityPanel />
          </div>
          <div class="modal-footer">
            <button 
              type="button" 
              class="btn btn-secondary" 
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  `,

  props: {
    tooltipText: {
      type: String,
      default: 'Data Import/Export',
    },
    modalId: {
      type: String,
      default: 'dataPortabilityModal',
    },
  },

  setup(props) {
    const modal = ref(null);
    let bootstrapModal = null;

    const openModal = () => {
      if (!bootstrapModal) {
        // Initialize Bootstrap modal
        bootstrapModal = new bootstrap.Modal(modal.value);
      }
      bootstrapModal.show();
    };

    const closeModal = () => {
      if (bootstrapModal) {
        bootstrapModal.hide();
      }
    };

    return {
      modal,
      openModal,
      closeModal,
    };
  },

  mounted() {},
};
